import React from "react";

const CharLimitTextArea = ({
  id,
  name,
  rows = 3,
  placeholder = "Type Here",
  onChange,
  value,
  maxLength = 250,
  required = false,
  lengthParam,
  disabled,
  className = "",
}) => {
  return (
    <>
      <textarea
        name={name}
        id={id}
        rows={rows}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        required={required}
        maxLength={maxLength}
        disabled={disabled}
        // className={`${disabled && "disabled"}`}
        className={`${className} ${disabled ? "disabled" : ""}`}
      ></textarea>
      <div className="badge badge-danger">
        Character Limit :&nbsp;
        {Number(lengthParam) + "/" + maxLength}
      </div>
    </>
  );
};

export default CharLimitTextArea;
